import SessionEventProto from "../session-event-proto"
import {SessionEventTeamHeader} from "./@type"

export default class SessionEvent_TeamDelete extends SessionEventProto {

    private header: SessionEventTeamHeader

    constructor(sessionEvent:any) {
        super(sessionEvent)

        this.header     = {
            team            : sessionEvent.team,
            isBulkUpdate    : sessionEvent.isBulkUpdate,
        }
    }

    process() {
        gd.session.teams.remove(this.header.team.id)

        gd.modelBus.newUpdate('team', this.method, this.header.team.id, this.data, this.header)
    }
}